<template>
	<div class="searcher">
		<v-select v-model="part_model"
				  @search="onSearch"
				  @input="on_select_part"
				  class="imc_reason"
				  :label="get_label_field"
				  :disabled="check_if_disabled()"
				  :searchable="can_search"
				  :options="part_options"
				  :filterable="false"
		>
			<template slot="no-options">
				{{text_show}}
			</template>

			<template slot="option" slot-scope="option">
				<div class="d-center">
					<div>
						{{ option.name }}
					</div>

					<div v-if="option.hasOwnProperty('number')">
						<small>По заміні :{{option.number}}</small>
					</div>

					<div>
						<small>Оригінал : {{option.numberOriginal}}</small>
					</div>
				</div>
			</template>
		</v-select>
	</div>
</template>

<script>
import vSelect from 'vue-select'
export default {
	name: "part_item",
	components: {
		vSelect
	},
	props : {
		table_item : {
			type : Object
		},
		item_type : {
			type : String
		},
	},

	data() {
		return {
			options : [],
		}
	},

	methods : {

		check_if_disabled() {
			if(this.item_type == 'non_original') {

			}
			return false;
		},

		onSearch(search, loading) {
			if(search.length > 1) {
				loading(true);
				this.search(loading, search);
			}
		},

		on_select_part(item) {
			console.log(item);
			if(this.item_type == 'non_original') {

			}

			this.$emit('on_select_part',{
				'idx' : this.table_item.index,
				'type' : this.item_type,
				'selected_part' : item,
			});
		},

		async search(loading, search)  {
			let self = this;
			let url = '/parts/suggest/'+ this.item_type + "/" + search;
			api.get(url).then(({data}) => {
				if(data.status === 'operation_success') {
					loading(false);
					self.part_options = data.data;
				}
			}).catch(({response}) => {
				loading(false);
				EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status,	position : "b-toaster-top-left"})
			});
		},
	},

	computed : {

		get_label_field() {
			if(this.item_type == 'original') {
				return "numberOriginal";
			}

			return "number";
		},


		text_show() {
			return 'Починайте вводити номер';
		},

		can_search() {
			if(this.item_type == 'non_original') {
				if (this.obj_to_null(this.selected_original)) {
					return false;
				}
			}
			return true;
		},

		part_model : {
			get() {
				if(this.item_type == 'original') {
					return this.selected_original;
				}

				return this.selected_non_original;
			},
			set(val) {
				console.log('on_set_val',val);
			}
		},

		inside_item() {
			return this.table_item.item;
		},


		selected_item() {
			return this.inside_item.selected_item;
		},


		selected_original() {
			if(this.selected_item.hasOwnProperty("original")) {
				return this.selected_item.original;
			}

			return null;
		},

		selected_non_original() {
			if(this.selected_item.hasOwnProperty("non_original")) {
				return this.selected_item.non_original;
			}

			return null;
		},

		part_options: {
			get() {

        /*if(this.item_type == 'non_original') {
					if(!this.can_search) {
						let self = this;
						if(this.selected_original.hasOwnProperty("numberNon-original")) {
							return this.selected_original['numberNon-original'].map(function (number) {
								return {
									"numberOriginal": self.selected_original.numberOriginal,
									"number": number,
									'name': self.selected_original.name,
									"measure": self.selected_original.measure,
								}
							});
						}
						return  [];
					}
					else {
						return this.options.map(function(item){
							return {
								"numberOriginal" 	: item.numberOriginal,
								"number" 			: item.number,
								'name' 				: item.name,
								"measure"			: item.measure,
							}
						});
					}
				}*/

				return this.options
			},

			set(val) {
				this.options = val;
			}
		}
	}
}
</script>

<style scoped>

</style>
